import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/quotationActions';
import { quotationsAPI, ordersAPI } from '../../api/config';

function* createQuotationSaga(action) {
  try {
    const response = yield call(quotationsAPI.create, action.payload);
    yield put(actions.createQuotationSuccess(response.data));
    message.success(`Quotation ${response.data.quotation_number} created successfully`);
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to create quotation';
    yield put(actions.createQuotationFailure(msg));
    message.error(msg);
  }
}

function* fetchQuotationsSaga(action) {
  try {
    const response = yield call(quotationsAPI.list, action.payload);
    yield put(actions.fetchQuotationsSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch quotations';
    yield put(actions.fetchQuotationsFailure(msg));
    message.error(msg);
  }
}

function* fetchQuotationSaga(action) {
  try {
    const response = yield call(quotationsAPI.get, action.payload);
    yield put(actions.fetchQuotationSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch quotation';
    yield put(actions.fetchQuotationFailure(msg));
  }
}

function* updateQuotationStatusSaga(action) {
  try {
    const { id, status } = action.payload;
    const response = yield call(quotationsAPI.updateStatus, id, { status });
    yield put(actions.updateQuotationStatusSuccess(response.data));
    message.success(`Quotation status updated to ${status}`);
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to update quotation status';
    yield put(actions.updateQuotationStatusFailure(msg));
    message.error(msg);
  }
}

// Convert flow:
//  1. The PO was already created by the caller via the normal PO saga.
//  2. This saga just calls the convert endpoint with the PO ID.
function* convertQuotationSaga(action) {
  try {
    const { quotationId, purchaseOrderId } = action.payload;
    const response = yield call(quotationsAPI.convert, quotationId, {
      purchase_order_id: purchaseOrderId,
    });
    yield put(actions.convertQuotationSuccess(response.data));
    message.success(`Quotation marked as converted — linked to PO #${purchaseOrderId}`);
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to convert quotation';
    yield put(actions.convertQuotationFailure(msg));
    message.error(msg);
  }
}

function* fetchComparativeSaga(action) {
  try {
    const response = yield call(quotationsAPI.getComparative, action.payload);
    yield put(actions.fetchComparativeStatementSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch comparative statement';
    yield put(actions.fetchComparativeStatementFailure(msg));
    message.error(msg);
  }
}

export default function* quotationSaga() {
  yield takeLatest(types.CREATE_QUOTATION_REQUEST, createQuotationSaga);
  yield takeLatest(types.FETCH_QUOTATIONS_REQUEST, fetchQuotationsSaga);
  yield takeLatest(types.FETCH_QUOTATION_REQUEST, fetchQuotationSaga);
  yield takeLatest(types.UPDATE_QUOTATION_STATUS_REQUEST, updateQuotationStatusSaga);
  yield takeLatest(types.CONVERT_QUOTATION_REQUEST, convertQuotationSaga);
  yield takeLatest(types.FETCH_COMPARATIVE_STATEMENT_REQUEST, fetchComparativeSaga);
}
